import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {RetailLocationsProductCatalogueWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/retailLocationsProductCatalogueWorkspaceCapability/domain/RetailLocationsProductCatalogueWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type RetailLocationsProductCatalogueWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.retailLocationsProductCatalogue> & {
    fixedUdoTemplates: {
        [RetailLocationsProductCatalogueWorkspaceCapabilityUdoTemplateKey.selection]: {
            udoAdditionalColumnIds: {
                productCatalogueId: Uuid;
                retailLocationId: Uuid;
                status: Uuid;
            };
        };
    };
};

export const retailLocationsProductCatalogueWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [RetailLocationsProductCatalogueWorkspaceCapabilityUdoTemplateKey.selection]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({
                status: uuidZodValidator,
                productCatalogueId: uuidZodValidator,
                retailLocationId: uuidZodValidator,
            }),
            udoTemplateId: uuidZodValidator,
        }),
    }),
}) satisfies zod.ZodType<RetailLocationsProductCatalogueWorkspaceCapabilityUdoBindings>;
